import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback" }
const _hoisted_2 = { class: "feedback-wrapper" }
const _hoisted_3 = { class: "feedback-row" }
const _hoisted_4 = { class: "feedback-header" }
const _hoisted_5 = { class: "feedback-header--title" }
const _hoisted_6 = { class: "h4 bold" }
const _hoisted_7 = { class: "feedback-content" }
const _hoisted_8 = { class: "form-screen__body" }
const _hoisted_9 = { class: "feedback-content--form" }
const _hoisted_10 = { class: "feedback-content--checkbox" }
const _hoisted_11 = { class: "feedback-content--btn form-screen__footer" }

import BaseInput from "@/components/base/BaseInput.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseSelect from "@/components/base/BaseSelect.vue";
import BaseDrop from "@/components/base/BaseDrop.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useFeedback } from "@/composables/feedback/useFeedback";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackView',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const {
  files,
  form,
  isAccepted,
  isEmailError,
  isEmptyPhoneEmailWithErrors,
  isErrorModal,
  isSuccessModal,
  isValidPhone,
  isValidType,
  selectArr,
  sendForm,
  toggleModal,
  validateEmail,
} = useFeedback();

const goBack = () => {
  router.push("/settings");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "feedback-header--back",
              onClick: goBack
            }, [
              _createVNode(BaseFigureForIcon, {
                size: "medium",
                color: "white",
                icon: "arrow",
                position: "left",
                "is-button": ""
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("feedback.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(BaseSelect, {
                  modelValue: _unref(form).theme,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).theme) = $event)),
                  placeholder: _unref(t)('feedback.themePlaceholder'),
                  items: _unref(selectArr)
                }, null, 8, ["modelValue", "placeholder", "items"]),
                _createVNode(BaseInput, {
                  modelValue: _unref(form).type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).type) = $event)),
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (isValidType.value = false)),
                  "has-error": _unref(isValidType),
                  "max-length": 20,
                  type: "text",
                  placeholder: _unref(t)('feedback.deviceModelPlaceholder')
                }, null, 8, ["modelValue", "has-error", "placeholder"]),
                _createVNode(BaseInput, {
                  modelValue: _unref(form).phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).phone) = $event)),
                  onFocus: _cache[4] || (_cache[4] = ($event: any) => (isValidPhone.value = false)),
                  "has-error": _unref(isValidPhone),
                  "max-length": 12,
                  type: "phone",
                  placeholder: _unref(t)('feedback.phonePlaceholder')
                }, null, 8, ["modelValue", "has-error", "placeholder"]),
                _createVNode(BaseInput, {
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).email) = $event)),
                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (isValidType.value = false)),
                  onValidation: _unref(validateEmail),
                  "has-error": _unref(isEmailError),
                  type: "email",
                  placeholder: "Email"
                }, null, 8, ["modelValue", "onValidation", "has-error"]),
                _createVNode(BaseInput, {
                  modelValue: _unref(form).comment,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).comment) = $event)),
                  type: "area",
                  placeholder: _unref(t)('feedback.commentPlaceholder')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(BaseDrop, {
                  "onUpdate:files": _cache[8] || (_cache[8] = ($event: any) => (files.value = $event))
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(BaseCheckbox, {
                  modelValue: _unref(isAccepted),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isAccepted) ? (isAccepted).value = $event : null))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(BaseButton, {
                title: _unref(t)('feedback.submit'),
                disabled: _unref(isEmptyPhoneEmailWithErrors),
                onClick: _unref(sendForm)
              }, null, 8, ["title", "disabled", "onClick"])
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (_unref(isErrorModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: _unref(t)('feedback.errorTitle'),
            text: _unref(t)('feedback.errorText'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _cache[10] || (_cache[10] = ($event: any) => (_unref(toggleModal)(false, 'error'))),
            onAction: _cache[11] || (_cache[11] = ($event: any) => (_unref(toggleModal)(false, 'error')))
          }, null, 8, ["title", "text", "main-btn-title"]))
        : _createCommentVNode("", true),
      (_unref(isSuccessModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 1,
            title: _unref(t)('feedback.successTitle'),
            text: _unref(t)('feedback.successText'),
            "main-btn-title": _unref(t)('feedback.successAction'),
            onClose: _cache[12] || (_cache[12] = ($event: any) => (_unref(toggleModal)(false, 'success'))),
            onAction: _cache[13] || (_cache[13] = ($event: any) => (_unref(toggleModal)(false, 'success')))
          }, null, 8, ["title", "text", "main-btn-title"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})